var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "progress-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "progress-overlay",
            on: { click: _vm.handleOverlayClick },
          },
          [
            _c(
              "div",
              {
                staticClass: "progress-container",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "progress-header" },
                  [
                    _c("h3", { staticClass: "progress-title" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _vm._v(" "),
                    _vm.showCloseButton
                      ? _c("el-button", {
                          staticClass: "close-btn",
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: { click: _vm.handleClose },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "progress-content" }, [
                  _c("div", { staticClass: "progress-info" }, [
                    _c("span", { staticClass: "progress-text" }, [
                      _vm._v(_vm._s(_vm.statusText)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "progress-percentage" }, [
                      _vm._v(_vm._s(_vm.formattedPercentage) + "%"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress-bar-container" }, [
                    _c("div", { staticClass: "progress-bar-bg" }, [
                      _c(
                        "div",
                        {
                          staticClass: "progress-bar-fill",
                          class: {
                            "progress-error": _vm.isError,
                            "progress-success": _vm.isSuccess,
                          },
                          style: { width: _vm.percentage + "%" },
                        },
                        [
                          !_vm.isError && !_vm.isSuccess
                            ? _c("div", { staticClass: "progress-shine" })
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.showDetails
                    ? _c("div", { staticClass: "progress-details" }, [
                        _vm.speed
                          ? _c("div", { staticClass: "detail-item" }, [
                              _c("i", { staticClass: "el-icon-upload2" }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.speed))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.timeRemaining
                          ? _c("div", { staticClass: "detail-item" }, [
                              _c("i", { staticClass: "el-icon-time" }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.timeRemaining))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fileSize
                          ? _c("div", { staticClass: "detail-item" }, [
                              _c("i", { staticClass: "el-icon-document" }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.fileSize))]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showActions
                    ? _c(
                        "div",
                        { staticClass: "progress-actions" },
                        [
                          _vm.canCancel && !_vm.isSuccess && !_vm.isError
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleCancel },
                                },
                                [_vm._v("\n            取消\n          ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isError && _vm.canRetry
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleRetry },
                                },
                                [_vm._v("\n            重试\n          ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isError && !_vm.canRetry
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleClose },
                                },
                                [_vm._v("\n            关闭\n          ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSuccess
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleComplete },
                                },
                                [_vm._v("\n            完成\n          ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }